export default __webpack_public_path__ + "static/media/ifeanyi.9c5d826b.png";